export default "__VITE_ASSET__cqbA5FiAbC0_ukYnXhHq9A__"